export default __webpack_public_path__ + "static/employees-workflow-portal-a02d848ca2dcce33d69f78a5c7154bc7.png";